import type { CardType } from "@fate-kingdom/card-data";

import {
  ARMY_DEPLOYMENT_TEST_CARD_CATALOG,
  ARMY_DEPLOYMENT_TEST_DECK,
  ARMY_DEPLOYMENT_TEST_DECK_CARD_IDS,
  ARMY_DEPLOYMENT_TEST_ENGINE_CATALOG,
} from "./army-deployment-card-fixtures.js";

/**
 * Test-only Core Battle policy: until deferred systems are implemented, a
 * replayable full-turn fixture may contain only card types the engine can
 * currently execute.
 */
export const CORE_BATTLE_EXECUTABLE_CARD_TYPES = ["land", "commander", "army"] as const;

const executableTypes = new Set<CardType>(CORE_BATTLE_EXECUTABLE_CARD_TYPES);
const definitionsById = new Map(
  ARMY_DEPLOYMENT_TEST_CARD_CATALOG.cards.map((card) => [card.id, card]),
);

for (const entry of ARMY_DEPLOYMENT_TEST_DECK.cards) {
  const definition = definitionsById.get(entry.cardId);
  if (definition === undefined || !executableTypes.has(definition.type)) {
    throw new Error(`Core Battle fixture deck contains a deferred card: ${entry.cardId}.`);
  }
}

export const CORE_BATTLE_TEST_CARD_CATALOG = ARMY_DEPLOYMENT_TEST_CARD_CATALOG;
export const CORE_BATTLE_TEST_ENGINE_CATALOG = ARMY_DEPLOYMENT_TEST_ENGINE_CATALOG;
export const CORE_BATTLE_TEST_DECK = ARMY_DEPLOYMENT_TEST_DECK;
export const CORE_BATTLE_TEST_DECK_CARD_IDS = ARMY_DEPLOYMENT_TEST_DECK_CARD_IDS;
